export default "__VITE_ASSET__BSV66pat__"